import get from 'lodash/get';
import * as Types from './types';

const TypeIcons = {
  [Types.website]: 'website',
  [Types.metaSite]: 'meta-site',
};

const getTypeIcon = type => get(TypeIcons, type, 'website-picker-default');

export default getTypeIcon;
